<template>
  <div class="dlg">
    <header class="dlg__head">
      <div class="dlg__eyebrow">
        <span class="dlg__dot"></span>
        WAIZMANNVERGLEICH / HIGHTECH-LEISTUNGEN
      </div>
      <h2 class="dlg__title">
        Vergleich zahnärztlicher Hightech-Leistungen
      </h2>
      <p class="dlg__sub">
        Welche moderne Verfahren (Laser, Cerec, DVT, …) sind im Tarif enthalten?
        Ein „Ja" bedeutet: Leistung ist in den Versicherungsbedingungen
        ausdrücklich erwähnt.
      </p>
    </header>

    <div class="dlg__table-wrap">
      <table class="dlg__table dlg__table--compact">
        <thead>
          <tr>
            <th>Tarif</th>
            <th
              v-for="col in cols"
              :key="col.key"
              class="dlg__th-icon"
            >
              <TooltipHelper :toolkey="col.tooltip">
                <template v-slot:toolTipText>
                  <a>{{ col.label }}</a>
                </template>
              </TooltipHelper>
            </th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="t in alletarife" :key="t.tarif_id">
            <td class="dlg__td-tarif">
              <router-link v-if="t.antraglink" :to="t.antraglink">
                {{ t.un_name }}
              </router-link>
              <span v-else>{{ t.un_name }}</span>
              <span v-if="t.empfehlung_type > 0" class="dlg__tipp">Tipp</span>
              <div class="dlg__td-tarif-sub">{{ t.tarif_title }}</div>
            </td>
            <td
              v-for="col in cols"
              :key="col.key"
              class="dlg__td-icon"
            >
              <span v-if="t[col.field] === 'Ja'" class="dlg__yes">Ja</span>
              <span v-else class="dlg__no">–</span>
            </td>
            <td>
              <router-link v-if="t.antraglink" :to="t.antraglink" class="dlg__btn">
                Antrag &amp; Infopaket
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
  import { defineProps } from "vue";
  import TooltipHelper from "@/components/base/TooltipHelper.vue";

  defineProps({
    tarif: {
      type: Object,
      default: () => ({}),
    },
    berechnung: {
      type: Object,
      default: () => ({}),
    },
    alletarife: {
      type: Array,
      default: () => [],
    },
  });

  const cols = [
    { key: "laser", label: "Laser", tooltip: "laser", field: "nice_tarif_leistung_trend_laser" },
    { key: "mikro", label: "Mikros.", tooltip: "mikro", field: "nice_tarif_leistung_trend_opmikro" },
    { key: "cerec", label: "Cerec", tooltip: "cerec", field: "nice_tarif_leistung_trend_cerec" },
    { key: "dvt", label: "DVT", tooltip: "dvt", field: "nice_tarif_leistung_trend_dvt" },
    { key: "dna", label: "DNA", tooltip: "dna", field: "nice_tarif_leistung_trend_dna" },
    { key: "nark", label: "Nark.", tooltip: "nark", field: "nice_tarif_leistung_trend_narkose" },
    { key: "aku", label: "AKU.", tooltip: "aku", field: "nice_tarif_leistung_trend_aku" },
    { key: "pact", label: "Pact.", tooltip: "pact", field: "nice_tarif_leistung_trend_pact" },
    { key: "dros", label: "DROS", tooltip: "dros", field: "nice_tarif_leistung_trend_dros" },
    { key: "invisa", label: "Invisa.", tooltip: "invisa", field: "nice_tarif_leistung_trend_invisa" },
    { key: "aufb", label: "Aufb.", tooltip: "aufb", field: "nice_tarif_leistung_trend_aufbiss" },
    { key: "vect", label: "Vect.", tooltip: "vect", field: "nice_tarif_leistung_trend_vector" },
  ];
</script>

<style scoped>
  .dlg__th-icon,
  .dlg__td-icon {
    text-align: center !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
  .dlg__table--compact :deep(td),
  .dlg__table--compact :deep(th) {
    padding-top: 6px;
    padding-bottom: 6px;
  }
</style>
